// ============================================================================
// Steadfastly - Modal Component
// ============================================================================
import React from 'react';
import { Icons } from './Icons';

export function Modal({ 
  open, 
  onClose, 
  title, 
  children, 
  size = "md", 
  darkMode = false, 
  disableBackdropClose = false, 
  showCloseButton = true 
}) {
  if (!open) return null;
  
  const sizes = { 
    sm: "max-w-md", 
    md: "max-w-lg", 
    lg: "max-w-2xl", 
    xl: "max-w-4xl", 
    xxl: "max-w-6xl" 
  };
  
  const handleBackdropClick = (e) => {
    if (disableBackdropClose) {
      e.currentTarget.querySelector('.modal-content')?.classList.add('animate-shake');
      setTimeout(() => {
        e.currentTarget.querySelector('.modal-content')?.classList.remove('animate-shake');
      }, 300);
      return;
    }
    onClose();
  };
  
  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${darkMode ? "bg-black/70" : "bg-black/50"}`} 
      onClick={handleBackdropClick}
    >
      <div 
        className={`modal-content rounded-2xl shadow-2xl w-full ${sizes[size]} max-h-[90vh] overflow-hidden flex flex-col transition-all duration-300 ${
          darkMode 
            ? "bg-slate-900 border border-slate-700/50 shadow-black/50" 
            : "bg-white shadow-slate-200/50"
        }`} 
        onClick={e => e.stopPropagation()}
      >
        <div className={`px-6 py-4 flex items-center justify-between flex-shrink-0 ${
          darkMode 
            ? "border-b border-slate-700/50 bg-slate-800/50" 
            : "border-b border-slate-100 bg-gradient-to-r from-slate-50 to-blue-50/30"
        }`}>
          <div className={`font-semibold text-lg ${darkMode ? "text-slate-100" : "text-slate-900"}`}>
            {title}
          </div>
          {showCloseButton && (
            <button 
              onClick={onClose} 
              aria-label="Close modal"
              className={`p-2 rounded-lg transition-colors ${
                darkMode 
                  ? "text-slate-500 hover:text-white hover:bg-slate-700" 
                  : "text-slate-500 hover:text-slate-600 hover:bg-slate-100"
              }`}
            >
              <Icons.X className="w-5 h-5" />
            </button>
          )}
        </div>
        <div className={`p-6 overflow-y-auto ${darkMode ? "text-slate-300" : "text-slate-700"}`}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
